import request from '../utils/request';
import Cookies from 'js-cookie';
const buildQuery = (filters) => {
    const params = new URLSearchParams();
    if (!filters) {
        return '';
    }
    const search = filters.search?.trim();
    if (search)
        params.append('search', search);
    if (filters.is_active !== undefined)
        params.append('is_active', String(filters.is_active));
    if (filters.parent)
        params.append('parent', filters.parent);
    const query = params.toString();
    return query ? `?${query}` : '';
};
export function fetchAdminProductCategories(filters) {
    return request()
        .get(`/api/v1/admin/product-categories/${buildQuery(filters)}`)
        .send();
}
export function createAdminProductCategory(payload) {
    const hasFile = typeof File !== 'undefined' && payload.header_image instanceof File;
    if (hasFile) {
        const formData = new FormData();
        formData.append('name', payload.name);
        formData.append('slug', payload.slug || '');
        formData.append('description', payload.description || '');
        formData.append('header_title', payload.header_title || '');
        formData.append('header_description', payload.header_description || '');
        formData.append('parent', payload.parent || '');
        formData.append('sort_order', String(payload.sort_order ?? 0));
        formData.append('is_active', String(payload.is_active ?? true));
        formData.append('header_image', payload.header_image);
        return fetch('/api/v1/admin/product-categories/', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'X-CSRFToken': Cookies.get('csrftoken') || '',
            },
            body: formData,
        });
    }
    return request()
        .post('/api/v1/admin/product-categories/')
        .send(payload);
}
export function updateAdminProductCategory(id, payload) {
    const hasFile = typeof File !== 'undefined' && payload.header_image instanceof File;
    if (hasFile) {
        const formData = new FormData();
        if (payload.name !== undefined)
            formData.append('name', payload.name);
        if (payload.slug !== undefined)
            formData.append('slug', payload.slug || '');
        if (payload.description !== undefined)
            formData.append('description', payload.description || '');
        if (payload.header_title !== undefined)
            formData.append('header_title', payload.header_title || '');
        if (payload.header_description !== undefined) {
            formData.append('header_description', payload.header_description || '');
        }
        if (payload.parent !== undefined)
            formData.append('parent', payload.parent || '');
        if (payload.sort_order !== undefined)
            formData.append('sort_order', String(payload.sort_order));
        if (payload.is_active !== undefined)
            formData.append('is_active', String(payload.is_active));
        formData.append('header_image', payload.header_image);
        return fetch(`/api/v1/admin/product-categories/${id}/`, {
            method: 'PATCH',
            credentials: 'include',
            headers: {
                'X-CSRFToken': Cookies.get('csrftoken') || '',
            },
            body: formData,
        });
    }
    return request()
        .patch(`/api/v1/admin/product-categories/${id}/`)
        .send(payload);
}
export function deleteAdminProductCategory(id) {
    return request()
        .delete(`/api/v1/admin/product-categories/${id}/`)
        .send();
}
export function fetchProductCategoryTree() {
    return request()
        .get('/api/v1/product-categories/tree/')
        .send();
}
export function fetchProductCategories(filters) {
    return request()
        .get(`/api/v1/product-categories/${buildQuery(filters)}`)
        .send();
}
